module.exports = __webpack_public_path__ + "media/audio3.5e64dbde.mp3";